function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100 0H0V80H100V0ZM45.455 68.9886H16.0004V50.5795C15.9237 35.5455 26.6623 18.9773 36.2504 11L53.739 19.8977C48.4464 28.7955 45.3783 38 45.455 50.5795V68.9886ZM83.8072 68.9886H54.3527V50.5795C54.276 35.5455 65.0146 18.9773 74.6027 11L92.0913 19.8977C86.7987 28.7955 83.7305 38 83.8072 50.5795V68.9886Z"
});

function SvgQuotesTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Quotes_quoteMark__341RR",
    viewBox: "0 0 100px 80px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesTop);
export default __webpack_public_path__ + "static/media/quotes-top.ad683acc.svg";
export { ForwardRef as ReactComponent };